import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import EditDigDayForm from "./EditDigDayForm";

const EditDigDayModal = ({ digDay }) => {
  const [modal, setModal] = useState(false);

  const toggle = () => setModal(!modal);

  const closeBtn = (
    <Button className="close" onClick={toggle}>
      &times;
    </Button>
  );

  return (
    <>
      <div data-toggle="tooltip" data-placement="bottom" title="Modifier le DigDay">
        <Button onClick={toggle} color="warning" outline size="sm">
          <i className="bx bxs-pencil" style={{ fontSize: "1.5em" }}></i>
        </Button>
      </div>
      <Modal isOpen={modal} toggle={toggle} backdrop="static" keyboard={false}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          Modifier le DigDay
        </ModalHeader>
        <ModalBody>
          <EditDigDayForm digDay={digDay} closeModal={() => setModal(false)} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default EditDigDayModal;
